import { useQuery } from '@tanstack/react-query';
import { getUserScopeConfigurationFull } from '../requests';
import { useSessionStore } from '@/entities/session';
import { useUserScopeConfiguration } from './useUserScopeConfiguration';

const useUserScopeConfigurationFull = () => {
  const { session } = useSessionStore();
  const { userScopeConfiguration } = useUserScopeConfiguration();
  const { data, isLoading, isFetching, error, refetch } = useQuery({
    queryKey: ['userScopeConfiguration', 'full', session?.userId],
    queryFn: getUserScopeConfigurationFull,
    enabled: !!session?.userId && !!userScopeConfiguration,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  return {
    userScopeConfigurationFull: data,
    isUserScopeConfigurationFullLoading: isLoading,
    isUserScopeConfigurationFullFetching: isFetching,
    userScopeConfigurationFullError: error,
    refetchUserScopeConfigurationFull: refetch,
  };
};

export { useUserScopeConfigurationFull };
